import { dependentKeyCompat } from "@ember/object/compat";
import { isPresent } from "@ember/utils";
import { addUniqueValueToArray } from "discourse/lib/array-tools";
import { deepEqual } from "discourse/lib/object";
import { i18n } from "discourse-i18n";

export default class SettingObjectHelper {
  constructor(settingObj) {
    this.settingObj = settingObj;
  }

  @dependentKeyCompat
  get overridden() {
    let val = this.settingObj.get("value");
    let defaultVal = this.settingObj.get("default");

    if (val === null) {
      val = "";
    }
    if (defaultVal === null) {
      defaultVal = "";
    }

    return !deepEqual(val, defaultVal);
  }

  @dependentKeyCompat
  get computedValueProperty() {
    if (isPresent(this.settingObj.get("valueProperty"))) {
      return this.settingObj.get("valueProperty");
    }

    const first = this.validValues?.[0];
    if (first && typeof first === "object" && "value" in first) {
      return "value";
    }
    return null;
  }

  @dependentKeyCompat
  get computedNameProperty() {
    if (isPresent(this.settingObj.get("nameProperty"))) {
      return this.settingObj.get("nameProperty");
    }

    if (isPresent(this.validValues?.[0]?.name)) {
      return "name";
    }
    return null;
  }

  @dependentKeyCompat
  get validValues() {
    const originalValidValues = this.settingObj.get("valid_values");
    const values = [];
    const translateNames = this.settingObj.translate_names;

    (originalValidValues || []).forEach((v) => {
      if (v.name && v.name.length > 0 && translateNames) {
        addUniqueValueToArray(values, { name: i18n(v.name), value: v.value });
      } else {
        addUniqueValueToArray(values, v);
      }
    });
    return values;
  }

  @dependentKeyCompat
  get allowsNone() {
    if (this.settingObj.get("valid_values")?.includes("")) {
      return "admin.settings.none";
    }
    return undefined;
  }

  @dependentKeyCompat
  get anyValue() {
    return this.settingObj.get("allow_any");
  }
}
